<div class="notification-list-container">
  <div class="notification-list-card">
    <div class="notification-list-header">
      <h2>Notification List</h2>
      <div class="search-box">
        <span class="p-input-icon-left">
          <i class="pi pi-search"></i>
          <input
            pInputText
            type="text"
            [(ngModel)]="searchText"
            (input)="applyFilter()"
            placeholder="Search notifications..."
          />
        </span>
      </div>
    </div>

    <p-table
      [value]="filteredNotifications"
      [paginator]="true"
      [rows]="10"
      [sortField]="'createdOn'"
      [sortOrder]="-1"
      [tableStyle]="{ 'min-width': '100%' }"
    >
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 20%">
            Client
          </th>
          <th style="width: 45%">Notification Content</th>
          <th style="width: 20%">
            Received On
          </th>
          <th style="width: 15%; text-align: center">Actions</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-notification>
        <tr>
          <td>{{ notification.additionalInfo?.clientName || '—' }}</td>
          <td>{{ notification.templateContent }}</td>
          <td>{{ notification.createdOn | date: 'MM/dd/yyyy hh:mm a' }}</td>
          <td style="text-align: center">
            <button
              pButton
              type="button"
              icon="pi pi-eye"
              class="p-button-rounded p-button-outlined p-button-success"
              (click)="readMore(notification)"
              pTooltip="View Results"
              tooltipPosition="top"
            ></button>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="4" class="text-center empty-message">No notifications found</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
